<template>
	<div class="body">
		<div class="banner"></div>
		
		<div class="login">
			<div class="title flex-baseline">
				<h1>统一认证登录</h1>
				<p>TACS SSO</p>
			</div>
			
			<div v-if="loading" class="state flex-center">
				<p>{{loadingText}}</p>
			</div>
			
			<div v-else class="state">
				<p class="error-text">{{errorMsg}}</p>
				<button @click="goLogin">返回登录页</button>
			</div>
		</div>
	</div>
</template>

<script>
	import fun from '@/assets/script/function.js'
	
	export default {
		data() {
			return {
				loading: true,
				loadingText: '正在登录...',
				errorMsg: ''
			};
		},
		
		mounted() {
			const query = this.$route.query;
			
			if (query.error) {
				this.handleError('登录失败，请重试');
				return;
			}
			
			if (!query.code) {
				this.handleError('登录失败，缺少授权码');
				return;
			}
			
			this.request({
				url: '/auth/tacs_sso/check',
				data: {
					code: query.code
				},
				loading: false,
				success: data => {
					// 后端已自动注册并登录，统一返回sessionId
					fun.setCookie('session_id', data.sessionId);
					this.$store.commit('setUserInfo', data.userInfo);
					if (data.needComplete) {
						this.navigateTo('/register');
					} else {
						this.navigateTo('/');
					}
				},
				fail: (code, obj, msg) => {
					this.$message({
						text: msg
					});
					this.navigateTo('/login');
				}
			});
		},
		
		methods: {
			handleError(msg) {
				this.loading = false;
				this.errorMsg = msg;
				setTimeout(() => {
					this.navigateTo('/login');
				}, 1500);
			},
			goLogin() {
				this.navigateTo('/login');
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.body {
		height: 100vh;
		overflow: hidden;
		background: #fff;
	}
	
	.banner {
		height: 4.7rem;
		margin-bottom: -.4rem;
		background-image: url('~@/assets/image/login/bg.jpg');
		background-position: center;
		background-size: cover;
	}
	
	.login {
		border-radius: .4rem .4rem 0 0;
		padding: .86rem .75rem;
		background: #fff;
		
		.title {
			gap: .16rem;
			margin-bottom: .36rem;
			font-size: .24rem;
			color: #bbb;
			
			h1 {
				font-size: .52rem;
				font-weight: normal;
				color: #000;
			}
		}
		
		.state {
			padding: 1.2rem 0;
			text-align: center;
			
			p {
				font-size: .32rem;
				color: #666;
			}
			
			.error-text {
				margin-bottom: .6rem;
				color: #ff4d4f;
			}
		}
		
		button {
			display: block;
			width: 100%;
			height: .96rem;
			border: none;
			border-radius: .48rem;
			font-size: .36rem;
			color: #fff;
			background: #0366F1;
		}
	}
</style>
